import { toast } from "sonner";

export const STATE_TONE = {
  dns: "bg-slate-100 text-slate-700 border-slate-200",
  verifying: "bg-sky-50 text-sky-700 border-sky-200",
  certificate: "bg-sky-50 text-sky-700 border-sky-200",
  switch: "bg-amber-50 text-amber-800 border-amber-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  problem: "bg-red-50 text-red-700 border-red-200",
};

export const relName = (name, apex) => (name === apex ? "@" : apex && name.endsWith(`.${apex}`) ? name.slice(0, -(apex.length + 1)) : name);

export const validHost = (raw) => /^([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z][a-z0-9-]*[a-z0-9]$/.test(rootOf(raw).host || "");

export const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

export const ISSUERS = { lets_encrypt: "Let's Encrypt", letsencrypt: "Let's Encrypt", google: "Google Trust Services", ssl_com: "SSL.com" };

export const daysLeft = (iso) => Math.max(0, Math.ceil((new Date(iso).getTime() - Date.now()) / 86400000));

export const needsPolling = (list) => !!list?.domains?.some((d) => !d.serving || ["problem", "switch"].includes(d.state));

export const sslProblem = (d) => d.problems.some((p) => p.code.startsWith("ssl_"));

export async function copyText(text) {
  try { await navigator.clipboard.writeText(text); toast.success("Copiato negli appunti"); }
  catch { toast.error("Copia non riuscita: seleziona il testo e copialo a mano"); }
}

// root of the domain (cliente.it, cliente.co.uk): same idea as the server, only to adapt the form
export function rootOf(raw) {
  const h = (raw || "").trim().toLowerCase().replace(/^[a-z]+:\/\//, "").split(/[/?#:]/)[0].replace(/\.$/, "");
  const labels = h.split(".").filter(Boolean);
  if (labels.length < 2) return { host: h, root: null };
  const two = /^(co|com|org|net|ac|gov|ltd|plc|me)\.[a-z]{2}$/.test(labels.slice(-2).join("."));
  const n = two ? 3 : 2;
  const root = labels.length >= n ? labels.slice(-n).join(".") : null;
  return { host: h, root, kind: h === root ? "apex" : h === `www.${root}` ? "www" : "sub" };
}
